import React from 'react';
import { Outlet } from 'react-router-dom';
import { PaymentProvider } from '../../contexts/PaymentContext';
import FortunePayPalWrapper from '../fortune/FortunePayPalWrapper';

/**
 * 命理师预约支付布局包装器
 * 
 * 这个组件包装所有命理师预约支付相关的路由，提供必要的支付上下文。
 * 与PaymentLayoutWrapper不同，它使用FortunePayPalWrapper来避免加载PayPal SDK，
 * 因为命理师预约现在使用服务器端PayPal集成。
 */
const FortunePaymentWrapper = () => {
  return (
    <PaymentProvider>
      <FortunePayPalWrapper>
        <Outlet />
      </FortunePayPalWrapper>
    </PaymentProvider>
  );
};

export default FortunePaymentWrapper;